import axios from "axios";
import { getAuthToken } from "./tokenManager";
import promise from "q";

// const BASE_URL = "http://localhost:8085";
const BASE_URL = "https://qkd-webapp-vm.com:8085";

export const axiosApiCall = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export const axiosApiCallWithToken = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: "application/json, application/pdf, image/png, image/jpeg",
    "Content-Type": "application/json",
  },
});

// Request interceptor for axiosApiCallWithToken - always includes token
axiosApiCallWithToken.interceptors.request.use(
  (request) => {
    const token = getAuthToken();
    if (token) {
      request.headers.Authorization = `Bearer ${token}`;
    }
    console.log("Request with token:", request);
    return request;
  },
  (error) => {
    return promise.reject(error);
  },
);

// Response interceptor for axiosApiCallWithToken - handles token expiration
axiosApiCallWithToken.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      console.log("Token expired or invalid");
      console.log("Error response:", error.response);
      console.log("Error message:", error.message);

      // Token expired or invalid
      localStorage.removeItem('auth_token');
      localStorage.removeItem('name');
      localStorage.removeItem('surname');
      localStorage.removeItem('authority');
      localStorage.removeItem('doctor_page');
      localStorage.removeItem('admin_page');
      localStorage.removeItem('patient_id');
      localStorage.removeItem('staff_id');
      localStorage.removeItem('patient_data');
      
      // Store current URL for redirect after login
      const currentPath = window.location.pathname + window.location.search;
      if (!currentPath.includes('/login')) {
        localStorage.setItem('redirectAfterLogin', currentPath);
      }
      
      // Redirect to login
      window.location.href = '/login';
    }
    return promise.reject(error);
  }
);

// Request interceptor for axiosApiCall - includes token for profile change endpoints
axiosApiCall.interceptors.request.use(
  (config) => {
    // Add token for profile change review endpoints and authentication check
    if (config.url && (
      config.url.includes('/profileChangeRequest/') || 
      config.url.includes('/auth-check')
    )) {
      const token = getAuthToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    console.log("Request without token (unless profile change):", config);
    return config;
  },
  (error) => {
    return promise.reject(error);
  }
);

// Response interceptor for axiosApiCall - handles auth errors for profile change endpoints
axiosApiCall.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Handle authentication errors for profile change endpoints
      if (error.config.url && (
        error.config.url.includes('/profileChangeRequest/') ||
        error.config.url.includes('/auth-check')
      )) {
        localStorage.removeItem('auth_token');
        localStorage.removeItem('name');
        localStorage.removeItem('surname');
        localStorage.removeItem('authority');
        localStorage.removeItem('doctor_page');
        localStorage.removeItem('admin_page');
        localStorage.removeItem('patient_id');
        localStorage.removeItem('staff_id');
        localStorage.removeItem('patient_data');
        
        // Store current URL for redirect after login
        const currentPath = window.location.pathname + window.location.search;
        if (!currentPath.includes('/login')) {
          localStorage.setItem('redirectAfterLogin', currentPath);
        }
        
        // Redirect to login
        window.location.href = '/login';
      }
    }
    return promise.reject(error);
  }
);
